import { isFieldGroup } from '@modusign/react-signing';
import { FieldNode } from '@modusign/react-signing/types';
import cloneDeep from 'lodash/cloneDeep';
import { DeepReadonly } from 'ts-essentials';

export function removeFieldOverPageRange(
  fields: DeepReadonly<FieldNode[]>,
  pageRange: number,
  removeField: (id: string) => void
) {
  const cloned = cloneDeep(fields) as FieldNode[];
  removeFieldOverPageRangeDFS(cloned, pageRange, removeField);
}

function removeFieldOverPageRangeDFS(
  fields: FieldNode[],
  pageRange: number,
  removeField: (id: string) => void
) {
  const removeTargets: string[] = [];
  for (const field of fields) {
    if (isFieldGroup(field)) {
      removeFieldOverPageRangeDFS(field.children, pageRange, removeField);
      if (field.children.length === 0) {
        removeTargets.push(field.id);
      }
    } else if (field.position.page > pageRange) {
      removeTargets.push(field.id);
    }
  }
  removeTargets.forEach((target) => {
    const index = fields.findIndex(({ id }) => target === id);
    fields.splice(index, 1);
    removeField(target);
  });
}
